// src/components/products/ProductForm/GeneralInfoSections/MediaSection.jsx

import React from "react";
import { Box, Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const MediaSection = ({
    formData,
    isArabic,
    handleCoverImageChange,
    handleMultiImagesChange,
    isUploadingCover,
    isEdit,
}) => {
    return (
        <Grid container spacing={3}>
            {/* Cover Image */}
            <Grid item xs={12} >
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems:'center'}}>
                    <FormInput
                        label={isArabic ? 'صورة الغلاف' : 'Cover Image'}
                        labelImage={isArabic ? 'اختر صورة الغلاف' : 'Choose cover image'}
                        labelBioImage={
                            isArabic
                                ? 'اسحب وأسقط الصورة هنا أو انقر للاختيار'
                                : 'Drag & drop or click to upload'
                        }
                        type="file"
                        name="cover_image"
                        value={formData.cover_image_preview || ''}
                        onChange={handleCoverImageChange}
                        required={!isEdit}
                        isUploading={isUploadingCover}
                        errorMessage={formData.coverImageError}
                        successMessage={formData.coverImageSuccess}
                    />
                </Box>
            </Grid>

            {/* Product Images */}
            <Grid item xs={12} >
                <FormInput
                    type="multi-image"
                    value={formData.uploadedImages || []}
                    onChange={handleMultiImagesChange}
                    maxImages={10}
                    maxSizeMB={2}
                    required={false}
                />
            </Grid>
        </Grid>
    );
};

export default MediaSection;
